import React, { forwardRef } from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import DataTable from "react-data-table-component";
import FormNuevaCita from "./FormNuevaCita";
import { Toast,ToastContainer } from "react-bootstrap";


function ControlAsistencia() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const [items, setItems] = useState([]);
    const [dias, setDias] = useState();
    const [permisos, setPermisos] = useState([]);

    ////////////////////////////////////////////////////

    const [date, setDate] = useState('');
    const [time, setTime] = useState('');
    const [modalState, setModalState] = useState('hidden');
    const [extendedProps, setExtendedProps] = useState({});
    const [idCita, setIdCita] = useState('');
    const [idPaciente, setIdPaciente] = useState('');
    const [primerNombre, setPrimerNombre] = useState('');
    const [segundoNombre, setSegundoNombre] = useState('');
    const [primerApellido, setPrimerApellido] = useState('');
    const [segundoApellido, setSegundoApellido] = useState('');
    const [email, setEmail] = useState('');
    const [celular, setCelular] = useState('');
    const [tipoDocumento, setTipoDocumento] = useState('');
    const [numeroDocumento, setNumeroDocumento] = useState('');
    const [duracionCita, setDuracionCita] = useState('');
    const [estadoCita, setEstadoCita] = useState('');
    const [idEstadoCita, setIdEstadoCita] = useState('');
    const [unidadAtencion, setUnidadAtencion] = useState('');
    const [motivoConsulta, setMotivoConsulta] = useState('');
    const [verCita, setVerCita] = useState(false);
    const [puedeAtender, setPuedeAtender] = useState('');
    const [idUsuarioAgenda, setIdUsuarioAgenda] = useState('');
    const [idUnidadAgenda, setIdUnidadAgenda] = useState('');
    const [primeraVez, setPrimeraVez] = useState();
    const [horaAtencionCita, setHoraAtencionCita] = useState();
    const [minutoCita, setMinutoCita] = useState();
    const [ampmCita, setAmpmCita] = useState();
    const [profesionalAsignado, setProfesionalAsignado] = useState();
    const [usuarioAgenda, setUsuarioAgenda] = useState();
    const [nombreProfesionalAsignado, setNombreProfesionalAsignado] = useState('');
    const [nombreUsuarioAsigna, setNombreUsuarioAsigna] = useState('');
    const [toastMsg, setToastMsg] = useState('');
    const [showToast, setShowToast] = useState(false);

    ////////////////////////////////////////////////////


    let userdata = [];
    let clientData = [];

    const cols = [
        { name:'Días desde última cita', selector:row => getDias(row.fecha_ultima_cita), sortable:false },
        { name:'Fecha última cita', selector:row => row.fecha_ultima_cita, sortable:false },
        { name:'Paciente', selector:row => getNombre(row), sortable:true },
        { name:'Celular', selector:row => row.celular, sortable:false },
        { name:'Teléfono', selector:row => row.telefono, sortable:false },
        { name:'Acción', selector:row => permisos.includes('crearCitas') ? <button className="btn btn-primary btn-sm" onClick={() => agendarCita(row)}>Agendar cita</button> : <></>, sortable:false },
    ];

    const getDias = (fecha) => {

        let arrayFecha = fecha.split('-');

        let hoy = new Date();
        let fechaUltimaCita = new Date(arrayFecha[0],arrayFecha[1]-1,arrayFecha[2]);

        let diferencia = hoy.getTime() - fechaUltimaCita.getTime();

        return Math.floor(diferencia/86400000);
    }

    const getNombre = (item) => {

        let segundoNombrePaciente = item.segundo_nombre ? ' '+item.segundo_nombre : '';
        let segundoApellidoPaciente = item.segundo_apellido ? ' '+item.segundo_apellido : '';
        let nombrePaciente = item.primer_nombre + segundoNombrePaciente + ' ' + item.primer_apellido + segundoApellidoPaciente;

        return nombrePaciente;
    }


    function leadingZero(val) {
        if (val<10) {
            return '0'+val;
        }
        else {
            return val;
        }
    }


    function agendarCita(paciente) {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const fechaISO = new Date();
        const fechaCita = fechaISO.getFullYear()+'-'+leadingZero(fechaISO.getMonth()+1)+'-'+leadingZero(fechaISO.getDate());

        setDate(fechaCita);
        setExtendedProps(null);

        //setHoraAtencionCita(getHoraCita(fechaISO.getHours()));
        //setMinutoCita(leadingZero(fechaISO.getMinutes()));
        //setAmpmCita(getAmpm(fechaISO.getHours()));

        setIdCita('');
        setPrimerNombre(paciente.primer_nombre);
        setSegundoNombre(paciente.segundo_nombre);
        setPrimerApellido(paciente.primer_apellido);
        setSegundoApellido(paciente.segundo_apellido);
        setEmail(paciente.email);
        setCelular(paciente.celular);
        setTipoDocumento(paciente.tipo_documento);
        setNumeroDocumento(paciente.numero_documento);

        setDuracionCita('');
        setEstadoCita('');
        setIdEstadoCita('');
        setUnidadAtencion('');
        setMotivoConsulta('');
        setVerCita(false);
        setPrimeraVez(true);
        setIdUsuarioAgenda(userdata.user_id);
        setNombreUsuarioAsigna(userdata.user_name+' '+userdata.user_lastname);

        setModalState('visible');
    }

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
            setPermisos(userdata.up);
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }
        
        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    //setUsername(userdata.user_name);
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log(error);
            });

    },[]);




    useEffect(() => {
        
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id,
                dias: dias
            }
        }

        axios.get('/pacientes-sin-citas',config)
            .then(response => {
                setItems(response.data);
            })
            .catch(error => {
                console.log(error);
            })

    },[dias]);


    function toastCita(msg) {
        
        setToastMsg(msg);
        setTimeout(() => { setShowToast(true) },800);
    }



    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc4">Control de asistencia</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Control de asistencia última cita</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                        <div className="row" style={{marginBottom: '30px'}}>
                             
                            <div className="col-md-8">
                                <div className="form-group" style={{display:'flex', alignItems: 'center', justifyContent: 'flex-start'}}>
                                    <label htmlFor="dias" style={{fontSize:'18px', fontWeight:'normal'}}>Consultar pacientes que no han tenido cita hace al menos </label>
                                    &nbsp;
                                    <input type="text" name="dias" className="form-control" id="dias" style={{width:'60px'}} onChange={(e) => setDias(e.target.value)} /> 
                                    &nbsp;
                                    <label style={{fontSize:'18px', fontWeight:'normal'}}>días</label>
                                </div>
                            </div>
                            
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                
                                <DataTable
                                columns={cols}
                                data={items}
                                pagination
                                id={'pacientes'}
                                />

                            </div>          
                        </div>

                        </div>
                    </section>
                </div>



                <FormNuevaCita 
                            modalState={modalState} 
                            closeModal={modalState => setModalState('hidden')} 
                            profesionalAsignado={profesionalAsignado}
                            nombreProfesionalAsignado={nombreProfesionalAsignado}
                            usuarioAsigna={usuarioAgenda}
                            nombreUsuarioAsigna={nombreUsuarioAsigna}
                            fecha={date}
                            hora={''}
                            reloadCitas={null}
                            reloadCitasAgenda={() => {}}
                            extendedProps={extendedProps}
                            primerNombre={primerNombre}
                            segundoNombre={segundoNombre}
                            primerApellido={primerApellido}
                            segundoApellido={segundoApellido}
                            email={email}
                            celular={celular}
                            tipoDocumento={tipoDocumento}
                            numeroDocumento={numeroDocumento}
                            verCita={false}
                            puedeAtender={false}
                            idPacienteExistente={idPaciente}
                            primeraVez={true}

                            notificacionCita={toastCita}
                            
                />
                
                <ToastContainer className="toast-exito">
                    <Toast onClose={() => setShowToast(false)} show={showToast} delay={4000} autohide>
                        <Toast.Body>{toastMsg}</Toast.Body>
                    </Toast>
                </ToastContainer>


                <Footer />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default ControlAsistencia;